import { useQuery } from '@tanstack/react-query';
import { fetchUnreadCount } from '../lib/messaging-api';
import { QUERY_KEYS } from '../lib/query-keys';
import { useWorkspace } from '../providers/WorkspaceProvider.shared';

export function useUnreadCount() {
  const { mode, companyId } = useWorkspace();
  // Socket UNREAD_COUNT events keep the cache authoritative: REST fires
  // once per cache entry; gcTime: Infinity prevents remount-after-eviction
  // from re-fetching during noisy re-renders (e.g. while sending a message).
  const { data, refetch } = useQuery({
    queryKey: [...QUERY_KEYS.UNREAD_COUNT, mode, companyId ?? null] as const,
    queryFn: () => fetchUnreadCount({ mode, companyId }),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { count: data ?? 0, refresh: refetch };
}
